/* eslint-disable jsx-a11y/no-access-key */
import React, { Suspense, useContext, useLayoutEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { CContainer, CFade } from "@coreui/react";

// routes config
import cgmfRoutes, { bidderRoutes, cfoRoutes, dfoRoutes } from "../routes";
import Auth from "src/auth";

import GetDynamicRoutes from "src/dynamicRoutes";
import MenuContext from "src/_components/ContextAPI";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import RouteComponentLoader from "./RouteComponentLoader";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const TheContent = () => {
  // const [routesAPI, setRoutesAPI] = useState([]);

  // useEffect(() => {
  //   const fetchRoutes = async () => {
  //     try {
  //       // Call your dynamic API to fetch routes
  //       if (authenticated && authenticated.role === "CGMF") {
  //         const dynamicRoutes = await GetDynamicRoutes(
  //           authenticated.role,
  //           menuList,
  //           authenticated.roleMasterId
  //         );
  //         setRoutesAPI([...cgmfRoutes, ...dynamicRoutes]);
  //       }
  //       // const response = await fetch("YOUR_API_ENDPOINT");
  //       // const data = await response.json();
  //       // setRoutes(data.routes);
  //     } catch (error) {
  //       console.error("Error fetching routes:", error);
  //     }
  //   };

  //   fetchRoutes();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const { authenticated } = Auth();
  const { menuList } = useContext(MenuContext);

  let routes;

  const [cgmfroute, setcgmfRoutes] = useState([]);

  const GetcgmfrouteData = async () => {
    if (authenticated && authenticated.role === "CGMF") {
      const dynamicRoutes = await GetDynamicRoutes(
        authenticated.role,
        menuList,
        authenticated.roleMasterId
      );
      setcgmfRoutes([...cgmfRoutes, ...dynamicRoutes]);
    }
  };
  useLayoutEffect(() => {
    GetcgmfrouteData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);
  if (authenticated.role === "CGMF") {
    routes = cgmfroute.map((route, idx) => {
      return (
        route.component && (
          <Route
            key={idx}
            path={route.path}
            exact={route.exact}
            name={route.name}
          >
            <RouteComponentLoader
              key={`d${idx}`}
              accessKey={route.accessKey}
              component={route.component}
              path={route.path}
            />
          </Route>
        )
      );
    });
  } else if (authenticated.role === "CFO") {
    routes = cfoRoutes.map((route, idx) => {
      return (
        route.component && (
          <Route
            key={idx}
            path={route.path}
            exact={route.exact}
            name={route.name}
            render={(props) => (
              <CFade>
                <route.component {...props} />
              </CFade>
            )}
          />
        )
      );
    });
  } else if (authenticated.role === "DFO") {
    routes = dfoRoutes.map((route, idx) => {
      return (
        route.component && (
          <Route
            key={idx}
            path={route.path}
            exact={route.exact}
            name={route.name}
            render={(props) => (
              <CFade>
                <route.component {...props} />
              </CFade>
            )}
          />
        )
      );
    });
  } else {
    routes = bidderRoutes.map((route, idx) => {
      return (
        route.component && (
          <Route
            key={idx}
            path={route.path}
            exact={route.exact}
            name={route.name}
            render={(props) => (
              <CFade>
                <route.component {...props} />
              </CFade>
            )}
          />
        )
      );
    });
  }
  return (
    // <main className="c-main" style={{ background: "#84E184" }}>
    <main className="c-main" style={{ background: "white" }}>
      <CContainer fluid>
        <Suspense fallback={loading}>
          <Switch>
            {routes}
            {authenticated.role !== "CGMF" && <Redirect to="/" />}
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  );
};

export default TheContent;
